import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Dialog } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import useAuthNavigation from '../useAuthNavigation';
import LoadingVerification from './VerifyingLoader';
import InvalidLink from '../login/InvalidLink';

function AuthActions() {
    const dispatch = useDispatch();
    const selector = useSelector((state) => state.firebaseAuth);
    const { backToLoginForm } = useAuthNavigation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [isInvalidSignInLink, setIsInvalidSignInLink] = React.useState(false);

    React.useEffect(() => {
        const mode = searchParams.get('mode');
        const oobCode = searchParams.get('oobCode');

        // navigate to hompage if user directly enter the url without mode and oobCode
        if (!mode || !oobCode) {
            navigate('/');
            return;
        }

        switch (mode) {
            case 'resetPassword':
                navigate(`/pages/reset-password/${oobCode}`);
                break;
            case 'signIn':
                // To be added later...
                break;
            case 'verifyingEmail':
                // To be added later...
                break;
            case 'recoverEmail':
                // To be added later...
                break;
            default:
                console.log('Default Case');
        }
    }, [searchParams, dispatch, navigate, selector.reEnteredEmail]);

    return (
        <Box sx={authActionContainer}>
            {isInvalidSignInLink ? (
                <Dialog open={true} sx={dialogStyles}>
                    <InvalidLink onClick={backToLoginForm} />
                </Dialog>
            ) : (
                <LoadingVerification />
            )}
        </Box>
    );
}

export default AuthActions;

const authActionContainer = {
    backgroundColor: 'var(--primary-color)',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '1rem'
};

const dialogStyles = {
    '& .MuiPaper-root': {
        width: '475px',
        // height: '555px',
        padding: '2rem',
        display: 'flex',
        border: 'none',
        borderRadius: '1rem',
        background: 'var(--gradient-blue)',
        scrollbarWidth: 'none'
    }
};
